import { render, staticRenderFns } from "./SMSstatusReturn.vue?vue&type=template&id=1457f684&scoped=true&"
import script from "./SMSstatusReturn.vue?vue&type=script&lang=js&"
export * from "./SMSstatusReturn.vue?vue&type=script&lang=js&"
import style0 from "./SMSstatusReturn.vue?vue&type=style&index=0&id=1457f684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457f684",
  null
  
)

export default component.exports